<template>
	<page enable-flex>
		<view-list ref="view" work-type="15" :search="{scan: true}">
			<template #filter>
				<m-search>
					<m-search-item label="产品信息">
						<c-input name="product_info" placeholder="品牌/型号/分类"></c-input>
					</m-search-item>
					<m-search-item label="创建时间">
						<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
					</m-search-item>
				</m-search>
			</template>

			<template #default="{data, index}">
				<view-list-card :key="index" :data="data">
					<template #tag>
						<c-state dict="LEVEL_TYPE" :value="data.level_type" type="hollow"></c-state>
					</template>

					<template #name>
						{{[data.brand_name, data.model_name, data.memory_name, data.color_name].filter(item => item).join(' ') || '-'}}
					</template>

					<template #state>
						<span v-if="sourceHandoverStateText(data)" :style="{color: isSourceRejectPending(data) ? '#e53e3e' : ''}">{{sourceHandoverStateText(data)}}</span>
						<c-state v-else dict="REPAIR_STATE" :value="data.repair_state" type="state"></c-state>
					</template>

					<template #default>
						<!-- 在途天数是接驳派生指标，H5 卡片是写死模板、不吃视图列配置，门店版不渲染 -->
						<c-field v-if="hasHandover" label="在途天数">{{data.in_transit_days}}天</c-field>
						<c-field label="背贴码">{{data.produce_unique_code}}</c-field>
						<c-field label="IMEI">{{data.produce_imei}}</c-field>
						<c-field label="采购价">￥{{data.purchase_price}}</c-field>
						<c-field v-if="data.repair_cost" label="维修价"><span style="color: #FF6900;">￥{{data.repair_cost}}</span></c-field>
					</template>

					<template #operate>
						<c-button v-if="data.buttons?.confirm_reject?.visible && auth('b_app_repair_confirm_reject')" color="main" hollow @click="confirmReject(data)">同意驳回</c-button>
						<!-- 行级按钮可见性由服务端业务状态与按钮权限共同控制 -->
						<c-button v-if="data.buttons?.transfer?.visible && auth('b_app_repair_transfer')" @click="mp.navigateWeb('/stock/allot', {code: data.produce_unique_code, from: 2})">调拨</c-button>
						<c-button v-if="data.buttons?.return_to_stock?.visible && auth('b_app_repair_return')" @click="returnToStock([data])">返库</c-button>
						<!-- 维修记录页的可操作性已改走 /repair/record/operateAuth 下发，不再把接驳状态与接驳人随背贴码传过去 -->
						<c-button v-if="data.buttons?.repair_record?.visible && auth('b_app_repair_record')" @click="mp.navigateWeb('/repair/record', {code: data.produce_unique_code})">维修记录</c-button>
					</template>
				</view-list-card>
			</template>
		</view-list>

		<template #handle>
			<c-button v-if="auth('b_app_repair_record_create')" color="main" hollow prepend-icon="tf-add" @click="mp.navigateWeb('/repair/record/edit')">添加维修记录</c-button>
			<c-button v-if="auth('b_app_repair_delivery_create')" color="main" prepend-icon="tf-repair" @click="mp.navigateWeb('/repair/delivery')">送修</c-button>
		</template>
	</page>
</template>

<script>
	import handoverReject from '@/mixins/handover_reject'
	import {mapGetters} from 'vuex'

	export default {
		mixins: [handoverReject],
		handoverModuleType: 2,
		computed: {
			...mapGetters(['hasHandover'])
		},

		data() {
			return {
			}
		},
		
		methods: {
			returnToStock(list) {
				this.$confirm({
					message: '确认要将该条记录返库吗？',
					resolve: () => {
						this.request({
							url: '/repair/return',
							data: {
								product_code_ids: list.map(item => item.produce_unique_code_id).join(',')
							},
							loading: true,
							success: () => {
								this.$message({
									message: '操作成功'
								});
								this.$refs.view.update();
							}
						});
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>